import { collection, doc, getDoc, getDocs, query, serverTimestamp, setDoc, updateDoc, where } from "firebase/firestore";
import React, { useContext, useState } from 'react';
import { AuthContext } from "../Context/AuthContext";
import { db } from "../firebase";

const Search = () => {
  const [userName, setUserName] = useState("");
  const [user, setUser] = useState(null);
  const [err, setErr] = useState(false);

  const {currentUser} = useContext(AuthContext)

  const handleSearch = async () =>{
    const q = query(
      collection(db, "users"),
      where("displayName", "==", userName)
    );

    try {
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        setUser(doc.data());
      });
      
    } catch (err) {
      setErr(err)
    }


  }

  const handleKey = (e) => {
    e.code === "Enter" && handleSearch();
  };

  const handleSelect =  async() => {
    // check whether the group(chat in firestore) exists, if not create
    const combinedId = currentUser.uid > user.uid ? currentUser.uid + user.uid : user.uid + currentUser.uid;
    try {
      const res = await getDoc(doc(db, "chats",combinedId));
      if(!res.exists()){
        // create a chat in chat Collection
        await setDoc(doc(db, "chats", combinedId), { messages: [] });
      }

      // Create user Chat
      await updateDoc(doc(db, "userChats", currentUser.uid), {
        [combinedId + ".userInfo"]: {
          uid: user.uid,
          displayName: user.displayName,
          photoURL: user.photoURL,
        },
        [combinedId + ".date"]: serverTimestamp(),
      });
      
      await updateDoc(doc(db, "userChats", user.uid), {
        [combinedId + ".userInfo"]: {
          uid: currentUser.uid,
          displayName: currentUser.displayName,
          photoURL: currentUser.photoURL,
        },
        [combinedId + ".date"]: serverTimestamp(),
      });
      
    } catch (err) { }
    setUser(null);
    setUserName("");
  }
  return (
    <div className='search'>
      <div className="searchForm">
        <input type="text" name=""  placeholder='Find a user' onKeyDown={handleKey}
          onChange={(e) => setUserName(e.target.value)}
          value={userName}
          />
      </div>
      {err && <span>User Not Found!</span>}
     {user && <div className="userChat" onClick={handleSelect}>
        <img src={user.photoURL} alt="" />
        <div className="userChatInfo">
          <span>{user.displayName}</span>
        </div>
      </div>}
    </div>
  )
}

export default Search